module.exports = __webpack_public_path__ + "static/brane-logo-6ece08719ed6290f912d7bb4fa091a5e.png";